// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 630 ? "cpv2008" : chunkId) + "." + {"96":"a9616f9e","239":"e49d061e","283":"715e966a","357":"f840db30","399":"ef8cfeb2","453":"1cc80243","510":"6956e20d","531":"74eab559","580":"7a2ca961","630":"7b278cc1"}[chunkId] + ".chunk.js";
};